// extracted by mini-css-extract-plugin
export default {"internationalSites":"KqOvkLQ"};